import backend from './backend';

export default {
    createStripeSession (customer) {
        return backend.get('/buyer/stripe/create_session', { params: { customer }})
    },
    savePaymentMethod (session_id) {
        return backend.post('/buyer/stripe/attach_payment_method', { session_id } )
    }
}